/* AUTO-SYNCED from PsyKit.io/lib/demo/sample-script.ts — DO NOT EDIT. Regenerate with `npm run sync`. */
/**
 * Sample script lines used by the InteractiveDemo's in-session view and by
 * any popup/modal previews. Intentionally generic phrasing — illustrates the
 * UI shape of the in-session ScriptPanel without functioning as clinical
 * guidance or quoting a copyrighted protocol.
 *
 * If you change these lines, also update:
 *   - the on-page disclaimer ("Sample prompts for UI illustration only —
 *     not clinical guidance.")
 *   - any social-screenshot copy that references the script preview
 */

export const SAMPLE_SCRIPT_LINES: readonly string[] = [
  "Bring the image to mind. Notice where you feel it in your body.",
  "Go with that. Just observe — nothing to fix, nothing to change.",
  "What comes up now? Let it be whatever it is.",
  "Stay with what you’re noticing. Let your eyes follow the ball.",
  "When you’re ready, take a breath. We’ll pause here.",
  "Now bring the image back to mind. What do you notice?",
  "How disturbing does it feel on a 0–10 scale, right now?",
  "Hold that. Follow the ball.",
  "Just notice what comes up. There’s no wrong answer.",
  "Let’s pause and check in. Tell me what you’re aware of.",
];
